// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__25tvL","title":"InfoRow_title__3w8gH"};